import {
  Box,
  Button,
  Container,
  FormHelperText,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate, useParams } from "react-router-dom";
import { AddSpecialRID } from "../../DAL/create";
import { GetSingleRID } from "../../DAL/fetch";
import { updateSingleSpecialRIDData } from "../../DAL/update";
import { enqueueSnackbar } from "notistack";
// AddSpecialRID
export const AddUpdateSpecialRID = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({
    price: "",
    specialId: "",
    pictureId: "",
  });
  const [type, setType] = useState("add");
  const [alert,setAlert]=useState("");
  const [priceError,setPriceError]=useState("");
  const [pictureError,setPictureError]=useState("");
  const FetchSingleRID = useCallback(async () => {
    const resp = await GetSingleRID(params?.id);
    if (resp?.data?.statusCode == 200) {
      setInputs({
        price: resp?.data?.data?.price,
        specialId: resp?.data?.data?.specialId,
        pictureId: resp?.data?.data?.picture?.id,
      });
      setType("edit");
    }
  }, [params?.id]);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value < 0 ? 0 :e.target.value;
    setInputs((val) => ({ ...val, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (inputs?.specialId?.length > 8) {
      setAlert("specialId has maximum 8 digits");
      return;
    }
    if (!inputs?.specialId) {
      setAlert("specialId field is required");
      return;
    }
    if (!inputs?.price) {
      setPriceError("price field is required");
      return;
    }
    if (!inputs?.pictureId) {
      setPictureError("pictureId field is required");
      return;
    }
    
    const data = {
      specialId: inputs?.specialId,
      pictureId: inputs?.pictureId,
      price: inputs?.price,
    };
    const resp =
      type == "add"
        ? await AddSpecialRID(data)
        : await updateSingleSpecialRIDData(params?.id, data);
    if (
      type == "add"
        ? resp?.data?.statusCode == 201
        : resp?.data?.statusCode == 200
    ) {
      enqueueSnackbar(resp?.data?.message, { variant: "success" });
      navigate(-1);
    } else {
      setAlert(resp?.error ? resp?.error : resp?.message);
    }
  };

  useEffect(() => {
    if (params?.id) {
      FetchSingleRID();
    }
  }, [params?.id]);

  const labelStyles = {
    color: "", // Default label color
    "&.Mui-focused": {
      color: "#8F29D0", // Focused label color (green)
    },
  };
  const inputStyles = {
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: "#8F29D0", // Hover border color
      },
      "&.Mui-focused fieldset": {
        borderColor: "#8F29D0", // Focus border color (green)
      },
    },
  };
  return (
    <>
      <Container maxWidth="xl" sx={{ marginTop: "5px" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <ArrowBackIcon
            sx={{ cursor: "pointer" }}
            onClick={() => navigate(-1)}
          />
          <Typography>
            {type == "add" ? "Add Special RID" : "Edit Special RID"}{" "}
          </Typography>
        </Box>
        <Grid container spacing={2} sx={{ marginTop: "5px" }}>
          <Grid item lg={6}>
            <TextField
              label="Special RID *"
              name="specialId"
              fullWidth
              value={inputs?.specialId}
              onChange={handleChange}
              size="small"
              type="number"
              sx={inputStyles}
        InputLabelProps={{ sx: labelStyles }}
            />
           
            <FormHelperText sx={{ color: "red" }}>
              {alert}
            </FormHelperText>
          </Grid>
          <Grid item lg={6}>
            <TextField
              label="Price *"
              name="price"
              value={inputs?.price}
              fullWidth
              onChange={(e)=>setInputs((prev)=>({...prev,"price":e.target.value < 0 ? 0:e.target.value}))}
              size="small"
              type="number"
              sx={inputStyles}
        InputLabelProps={{ sx: labelStyles }}
            />
            

             <FormHelperText sx={{ color: "red" }}>
              {priceError}
            </FormHelperText>
            
          </Grid>
          <Grid item lg={6}>
            <TextField
              label="Image Id *"
              name="pictureId"
              fullWidth
              value={inputs?.pictureId}
              onChange={handleChange}
              size="small"
              type="text"
              sx={inputStyles}
        InputLabelProps={{ sx: labelStyles }}
            />
            

            <FormHelperText sx={{ color: "red" }}>
              {pictureError}
            </FormHelperText>
            
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12} sx={{ textAlign: "end" }}>
            <Button
              className="gradientButton"
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};
